export default __webpack_public_path__ + "static/media/quick-prequal.6f0f34ef.svg";